import {
  CalendarDateTime,
  fromDate,
  getLocalTimeZone,
  ZonedDateTime,
  type DateValue,
} from '@internationalized/date';

export function isoStringToDateValue(iso: string | null | undefined): DateValue | undefined {
  if (!iso?.trim()) return undefined;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return undefined;
  return fromDate(d, getLocalTimeZone());
}

export function dateValueToIsoString(v: DateValue | null): string {
  if (v == null) return '';
  if (v instanceof ZonedDateTime) return v.toDate().toISOString();
  if (v instanceof CalendarDateTime) return v.toDate(getLocalTimeZone()).toISOString();
  return v.toDate(getLocalTimeZone()).toISOString();
}
